// Insert a row into the notes table. Mirrors the inline insert in
// components/documents/Notes.js (the "+ New note" button) so the same code
// path is reused by both the user-driven button and meet's applySuggestion.
//
// Returns the new row's id on success, null on failure.
//
// migrated 2026-04-27 to SDK route workspaceProject.documents.notes
import { getSDK } from '../../../shared/functions/sdk.js'

export const createNote = async function ({ title = 'Untitled note', content = '', tags = [], source = 'member' } = {}) {
  const root = this.state.root
  const row = {
    title,
    content,
    author: root.currentUserEmail || 'Unknown',
    source,    // 'member' | 'ai' — meet passes 'ai'
    tags
  }
  let data
  try {
    const result = await getSDK().execute('workspaceProject.documents.notes', 'create', { payload: row })
    data = result?.data || result
  } catch (err) {
    console.error('[createNote] insert failed', err)
    return null
  }
  if (!data?.id) return null
  // Optimistic state merge so the new note appears immediately in /documents/notes.
  const existing = root.notes || []
  root.update({
    notes: [...existing, {
      id: data.id,
      ...row,
      createdAt: new Date().toISOString().slice(0, 10)
    }],
    selectedNoteId: data.id
  })
  return data.id
}
